// auto-generated by bin/genVersion.ts
export const VERSION = '1.17.1';
//# sourceMappingURL=version.js.map